var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"es-notification-bubble",class:{ 'es-notification-bubble--pulse': _vm.pulse }},[_vm._v("\n  "+_vm._s(_vm.notifications)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }